<script setup>
const model = defineModel();
defineProps({
  label: String,
  icon: String,
  placeholder: {
    type: String,
    default: "",
  },
  type: {
    type: String,
    default: "text",
  },
});
</script>
<template>
  <div>
    <label
      :for="label"
      class="block text-sm font-medium text-slate-700 dark:text-slate-300"
      >{{ label }}</label
    >
    <div class="relative mt-1 rounded-md">
      <div
        class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none"
      >
        <span class="grid text-sm place-content-center text-slate-400">
          <i :class="`fa-solid fa-${icon}`"></i>
        </span>
      </div>
      <input
        :type="type"
        :name="label"
        :placeholder="placeholder"
        v-model="model"
        class="block w-full px-3 py-2.5 pl-10 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400 transition-colors duration-200"
      />
    </div>
  </div>
</template>
